import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react-lite";

import AppStore from "stores/AppStore";
import InvoiceStore from "stores/InvoiceStore";

import "./InvoiceState.scss";

const InvoicePreview = () => {
    const {
        invoice: {
            invoiceData: { status }
        }
    } = InvoiceStore;

    const {
        i18n: {
            invoicePreview: { weAreProcessingYourInvoice, weWillSendYouSlackMessage, invoiceIssued }
        }
    } = AppStore;

    const renderTexts = () => {
        let header = "";
        let subHeader = "";

        switch (status) {
            case "processing":
                header = weAreProcessingYourInvoice;
                subHeader = weWillSendYouSlackMessage;
                break;
            default:
                header = invoiceIssued;
                break;
        }

        return (
            <div className="c-invoice-state__texts-wrapper">
                <div className="c-invoice-state__icon">
                    <FontAwesomeIcon icon={faCheck} />
                </div>
                <div className="c-invoice-state__texts">
                    <h3 className="c-invoice-state__header">{header}</h3>
                    <p className="c-invoice-state__sub-header">{subHeader}</p>
                </div>
            </div>
        );
    };

    return (
        <div className="c-invoice-state">
            <div className="c-invoice-state__state">
                {renderTexts()}
            </div>
        </div>
    );
};

export default observer(InvoicePreview);
